

import DispatchRequests from "@/views/OrderDetail/components/DispatchRequests.vue";
import {checkDispatchRequestIsPickupableWithCode} from "@/helpers/dispatch-requests";
import axios from "axios";

export default {
    name: "OrderPickupWithCode",
    components: {DispatchRequests},

    props: {
        salesOrder: {required: true, type: Object},
    },

    data() {
        return {
            isLoading: true,
            isProcessing: false,
            isNoPickupCodeCardOpen: false,
            isInvalidCode: false,
            isResendingCode: false,
            scannedCode: '',
            dispatchRequestsToPickup: [] as Record<string, any>[],
            scanResult: {
                dispatch_request: null as Record<string, any> | null,
                was_already_picked_up: null as Boolean | null,
                picked_up_at: null as string | null,
            },
        }
    },

    async mounted() {
        window.addEventListener("hashchange", () => {
            this.handleHashChange();
        });

        if (window.location.hash.length) {
            await this.handleHashChange()
        }

        for (let drq of this.salesOrder.current_dispatch_requests_with_paused) {
            if (await checkDispatchRequestIsPickupableWithCode(drq)) {
                this.dispatchRequestsToPickup.push(drq);
            }
        }
    },

    beforeDestroy() {
        window.removeEventListener("hashchange", this.handleHashChange);
    },

    computed: {
    },

    methods: {
        async processCode(): Promise<void> {
            if (!this.scannedCode.trim().length) {
                return Promise.resolve();
            }

            this.isProcessing = true
            this.isNoPickupCodeCardOpen = false
            this.isInvalidCode = false

            return axios.post(`/api/rest/sales-orders/${this.salesOrder.identifier}/pickup-codes`, {
                pickup_code: this.scannedCode,
            })
                .then(response => {
                    this.scanResult = response.data;

                    if (this.scanResult.was_already_picked_up) {
                        this.scanResult.dispatch_request.status = 'shipped'
                    }
                })
                .catch(error => {
                    switch (error.response.status) {
                        case 404:
                            // @ts-ignore
                            this.isInvalidCode = true
                            break;
                        default:
                            // @ts-ignore
                            this.$alert(`Fout bij het verwerken van de code. Probeer het opnieuw.`, 'danger')
                            break;
                    }
                })
                .finally(() => {
                    this.scannedCode = '';
                    this.isProcessing = false;
                })
        },
        async resendCode(dispatchRequest: Record<string, any>): Promise<void> {
            this.isResendingCode = true;

            axios.post(`/api/rest/dispatch-requests/id:${dispatchRequest.id}/resend-pickup-code`)
                .then(response => {
                    // @ts-ignore
                    this.$alert(`De code is opnieuw verstuurd`);
                    this.getPickupCodeMailStatus(dispatchRequest);
                })
                .catch(error => {
                    // @ts-ignore
                    this.$alert(`Fout bij het versturen van de code. Probeer het opnieuw.`, 'danger');
                })
                .finally(() => {
                    this.isResendingCode = false;
                })
        },
        async getPickupCodeMailStatus(dispatchRequest: Record<string, any>): Promise<void> {
            this.$set(dispatchRequest, 'pickup_code_mail_status', undefined)
            this.$set(dispatchRequest, 'pickup_code_mail_address', undefined)

            return axios.get(`/api/rest/dispatch-requests/id:${dispatchRequest.id}/pickup-code-mail-status`)
                .then(response => {
                    this.$set(dispatchRequest, 'pickup_code_mail_status', response.data.is_successful)
                    this.$set(dispatchRequest, 'pickup_code_mail_address', response.data.email_address ?? 'onbekend e-mailadres')
                    this.$set(dispatchRequest, 'pickup_code_mail_sent_at', response.data.sent_at)
                })
                .catch(error => {
                    // @ts-ignore
                    this.$alert('Fout bij het ophalen van de status van de afhaalcode mail', 'danger')
                    dispatchRequest.pickup_code_mail_status = null;
                })
        },
        finish() {
            this.$emit('dataChanged')

            this.$router.push({
                name: 'OrderDetailOverview',
                params: {salesOrderIdentifier: this.salesOrder.identifier}
            })
        },
        async handleHashChange() {
            this.scannedCode = window.location.hash.substring(1)
            await this.processCode()
            window.location.hash = ''
        },
    },

    watch: {
        async isNoPickupCodeCardOpen(val) {
            if (val) {
                for (let drq of this.dispatchRequestsToPickup) {
                    if (!drq.pickup_code_mail_status) {
                        await this.getPickupCodeMailStatus(drq);
                    }
                }
            }
        },
        '$route.hash': {
            immediate: false,
            handler() {
                this.handleHashChange()
            },
        },
    },
}
